export default function cookieStorage() {
  window.cookieStorage = {
      getItem(key) {
          const cookies = document.cookie.split(';');
          for (let i = 0; i < cookies.length; i++) {
              const [cookieKey, cookieValue] = cookies[i].split('=');
              if (cookieKey && cookieKey.trim() === key) {
                  return decodeURIComponent(cookieValue);
              }
          }
          return null;
      },

      setItem(key, value, options = {}) {
          let cookie = `${key}=${encodeURIComponent(value)}`;

          const date = new Date();
          date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000); // 30 days
          cookie += `; expires=${date.toUTCString()}`;

          cookie += `; path=${options.path || '/'}`;
          document.cookie = cookie;
      },

      removeItem(key) {
          document.cookie = `${key}=; Max-Age=0; path=/`;
      }
  };
}
